import { ARROW_DOWN_KEY_CODE as W, ARROW_UP_KEY_CODE as m, ARROW_RIGHT_KEY_CODE as p, ARROW_LEFT_KEY_CODE as w } from "./index.es741.js";
import { baseOnKeyDown as o } from "./index.es742.js";
const Y = (_, E, O = !1) => {
  const { down: R, left: K, right: r, up: A } = E || {};
  o(_, W, R, O), o(_, m, A, O), o(_, p, r, O), o(_, w, K, O);
};
export {
  Y as onKeyDownArrows
};
//# sourceMappingURL=index.es527.js.map
